var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-flex',{class:['caption', _vm.align],attrs:{"shrink":""}},[_c('span',{class:['probability-capsule', _vm.colorClass]},[_vm._v(_vm._s(_vm.label))])])}
var staticRenderFns = []

export { render, staticRenderFns }